import localDeposit from '@/mixins/localDeposit.js'
import getBalance from '@/mixins/getBalance.js'
import provider from '@/mixins/provider.js'
export default {
  mixins: [localDeposit, getBalance, provider],
  data () {
    return {
      isAccountNameError: '',
      bankOptions: [],
      isSearchableBankName: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    isTransferable (currency, type) {
      const isAsset = type === 'asset'
      const transferDetails = this.depositSwapCurrencies
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      const details = transferDetails.find((detail) =>
        this.isSourceCurrency
          ? detail.from === currency && detail.to === this.secondaryCurrency
          : detail.from === this.activeCurrency && detail.to === currency
      )
      const walletDetails = this.walletAddresses.find(
        (wallet) => wallet.asset === currency && wallet.reason === 'deposit'
      )
      if (isAsset && this.isSourceCurrency && !walletDetails) {
        return false
      }
      if (sameCurrency) {
        return true
      }
      return this.isSourceCurrency || details?.is_enabled
    },
    async switchCurrency () {
      const vm = this
      if (this.isTransferable) {
        const activeCountry = this.country.name
        const secondaryCountry = this.country2.name
        this.$store.dispatch('common/setSecondaryCountry', activeCountry)
        this.$store.dispatch('common/setActiveCountry', secondaryCountry)
        if (this.inputAmountFieldIsNotEmpty) {
          // swap send amount to recipient amount
          const enteredAmountInput = this.enteredAmountForm.enteredAmount
          const recipientAmountInput = this.enteredAmountForm.recipientAmount
          if (this.firstInputSelected) {
            this.enteredAmountForm.enteredAmount = enteredAmountInput
            this.calcFirstInput()
          } else {
            this.enteredAmountForm.recipientAmount = recipientAmountInput
            this.calcSecondInput()
          }
        }
      } else {
        vm.$message({
          showClose: true,
          message: `Can't transfer from ${this.secondaryCurrency}  to ${this.activeCurrency} at the moment`,
          type: 'info'
        })
      }
    },
    calcFirstInput () {
      this.firstInputSelected = true
      this.calculate()
    },
    calcSecondInput () {
      this.firstInputSelected = false
      this.calculate()
    },
    handleInput (fieldName, calcFunction) {
      let pattern = /[^\d.]/g
      if (this.isHub2Provider) {
        pattern = /[^\d]/g
      }
      this.enteredAmountForm[fieldName] = this.enteredAmountForm[
        fieldName
      ].replace(pattern, '')

      calcFunction()
    },
    calculate () {
      if (this.firstInputSelected) {
        this.enteredAmountForm.recipientAmount = this.recipientAmount
      } else {
        this.enteredAmountForm.enteredAmount =
          this.switchRecipientAmount || this.enteredAmount
      }
    }
  },
  computed: {
    depositSwapCurrencies () {
      const depositAccounts = this.filteredDepositAccounts // Array of deposit accounts
      const transferDetails = this.$store.state.auth.transferDetails // Array of transfer details

      // Extract the currencies from depositAccounts into an array
      const depositCurrencies = depositAccounts.map(
        (account) => account.currency
      )

      // Create a new array with filtered transfer details
      const filteredTransferDetails = transferDetails.filter((detail) => {
        // Check if detail is enabled
        if (!detail.is_enabled) {
          return false
        }

        // Check if both 'from' and 'to' currencies exist in depositAccounts
        const fromExists = depositCurrencies.includes(detail.from)
        const toExists = depositCurrencies.includes(detail.to)

        // Return true if both 'from' and 'to' currencies are in deposit accounts
        return fromExists && toExists
      })

      return filteredTransferDetails
    }
  }
}
